import React from 'react';
import Error from './list/error';
import Check from './list/check';
import X from './list/x';
import EyeOutline from './list/eyeOutline';
import Calendar from './list/calendar';
import Delete from './list/delete';
import Topics from './list/bottomTabs/topics';
import Home from './list/bottomTabs/home';
import Logo from './list/logo';
import BottomTabsContainer from './list/bottomTabs/bottomTabsContainer';
import Menu from './list/menu';
import Record from './list/record';
import Genio from './list/genio';
import Facebook from './list/social/facebook';
import Google from './list/social/google';
import Apple from './list/social/apple';
import Back from './list/back';
import Add from './list/add';
import Edit from './list/edit';
import Policy from './list/drawer/policy';
import Privacy from './list/drawer/privacy';
import Settings from './list/drawer/settings';
import Stars from './list/drawer/stars';
import Support from './list/drawer/support';
import Terms from './list/drawer/terms';
import TopicsDrawer from './list/drawer/topicsDrawer';
import Backdrop from './list/backdrop';
import AiNews from './list/aiNews';
import Profile from './list/profile';
import ChangePassword from './list/changePassword';
import TextSize from './list/textSize';
import Languages from './list/drawer/languages';
import Filter from './list/filter';
import MiniMenu from './list/miniMenu';
import FilterSolid from './list/filterSolid';
import Pause from './list/pause';
import ArrowDown from './list/arrowDown';
import Library from './list/bottomTabs/library';
import Account from './list/bottomTabs/account';
import TabBackground from './list/bottomTabs/tabBackground';
import Notes from './list/bottomTabs/notes';
import Activity from './list/bottomTabs/activity';
import ViewAll from './list/viewAll';
import Star from './list/star';
import Arrows from './list/arrows';
import CalenderFilter from './list/calenderFilter';
import BottomTabFillContainer from './list/bottomTabs/bottomTabFillContainer';
import Subtract from './list/subtract';
import Circle from './list/circle';
import CircleProgress from './list/circleProgress';
import SeeAllButton from './list/seeAllButton';
import GestureHorizontal from './list/gestureHorizontal';
import GestureVertical from './list/gestureVertical';
import LongPress from './list/longPress';
import CustomizeHome from './list/drawer/customizeHome';
import Publisher from './list/publisher';
import BubbleTail from './list/bubbleTail';
import Chat from './list/chat';
import Favorite from './list/bottomTabs/favorite';
import OnboardingLogo from './list/onboardingLogo';
import NavArrow from './list/navArrow';
import HomeMic from './list/homeMic';
import Mic from './list/bottomTabs/mic';
// Menu icons
import ArrowRight from './list/menu/arrowRight';
import CustomerSupportMenu from './list/menu/customerSupportMenu';
import SettingsMenu from './list/menu/settingsMenu';
import TermsConditionsMenu from './list/menu/termsConditionsMenu';
import PrivacyPolicyFormMenu from './list/menu/privacyPolicyFormMenu';
import PrivacyPolicyMenu from './list/menu/privacyPolicyMenu';
import SpecialtyMenu from './list/menu/specialtyMenu';
import HomeMenu from './list/menu/homeMenu';
import LightMode from './list/menu/lightMode';
import MenuDarkMode from './list/menu/darkMode';
import MenuLogout from './list/menu/logout';
import MenuTextSize from './list/menu/textSize';
import ChangePass from './list/menu/changePass';
import AccountMenu from './list/menu/accountMenu';
import Phone from './list/phone';
import Email from './list/email';
// Toast icons
import SuccessAlert from './list/toast/successAlert';
import ErrorAlert from './list/toast/errorAlert';
import HelpAlert from './list/toast/helpAlert';
import SuccessBubble from './list/toast/successBubble';
import ErrorBubble from './list/toast/errorBubble';
import HelpBubble from './list/toast/helpBubble';
import WarningAlert from './list/toast/warningAlert';
import WarningBubble from './list/toast/warningBubble';
import Heart from './list/heart';
import Share from './list/share';
import User from './list/user';
import Lock from './list/lock';
import EyeOff from './list/eyeOff';
import KeyboardArrowDown from './list/keyboardArrowDown';
import History from './list/history';
import Search from './list/search';
import Plus from './list/plus';
import RecordBackground from './list/recordBackground';
import Wave from './list/wave';
import Send from './list/send';
import Speak from './list/speak';
import AdvanceSearch from './list/advanceSearch';
import ResetSearch from './list/resetSearch';
import FilterRemove from './list/filterRemove';
import Alert from './list/alert';
import Play from './list/play';
import Translate from './list/translate';
import Hearto from './list/hearto';
import WebClock from './list/webClock';
import Info from './list/info';
import Empty from './list/empty';
import Summaries from './list/summary/summaries';
import Analysis from './list/summary/analysis';
import Predictions from './list/summary/predictions';
import ArrowRightSmall from './list/arrowRightSmall';
import Erh from './list/drawer/erh';
import CheckSelect from './list/checkSelect';
import Download from './list/download';
import PromptSelect from './list/promptSelect';
import Copy from './list/copy';
import StarOutline from './list/starOutline';
import More from './list/more';
import ChatShare from './list/chatShare';
import ExportPdf from './list/exportPdf';
import CopyMessage from './list/copyMessage';
import Play2 from './list/play2';
import Pause2 from './list/pause2';
import Expand from './list/expand';
import Collapse from './list/collapse';

const icons = {
  error: <Error />,
  check: <Check />,
  x: <X />,
  close: <X />,
  delete: <Delete />,
  eyeOutline: <EyeOutline />,
  eyeOff: <EyeOff />,
  calendar: <Calendar />,
  menu: <Menu />,
  download: <Download />,
  topics: <Topics />,
  favorite: <Favorite />,
  home: <Home />,
  logo: <Logo />,
  bottomTabsContainer: <BottomTabsContainer />,
  record: <Record />,
  genio: <Genio />,
  facebook: <Facebook />,
  google: <Google />,
  apple: <Apple />,
  back: <Back />,
  add: <Add />,
  edit: <Edit />,
  policy: <Policy />,
  privacy: <Privacy />,
  settings: <Settings />,
  stars: <Stars />,
  support: <Support />,
  terms: <Terms />,
  topicsDrawer: <TopicsDrawer />,
  backdrop: <Backdrop />,
  aiNews: <AiNews />,
  profile: <Profile />,
  changePassword: <ChangePassword />,
  fontSize: <TextSize />,
  languages: <Languages />,
  filter: <Filter />,
  miniMenu: <MiniMenu />,
  filterSolid: <FilterSolid />,
  pause: <Pause />,
  arrowDown: <ArrowDown />,
  library: <Library />,
  account: <Account />,
  tabBackground: <TabBackground />,
  notes: <Notes />,
  activity: <Activity />,
  viewAll: <ViewAll />,
  star: <Star />,
  arrows: <Arrows />,
  calenderFilter: <CalenderFilter />,
  bottomTabFillContainer: <BottomTabFillContainer />,
  subtract: <Subtract />,
  circle: <Circle />,
  circleProgress: <CircleProgress />,
  seeAllButton: <SeeAllButton />,
  gestureHorizontal: <GestureHorizontal />,
  gestureVertical: <GestureVertical />,
  longPress: <LongPress />,
  customizeHome: <CustomizeHome />,
  publisher: <Publisher />,
  bubbleTail: <BubbleTail />,
  chat: <Chat />,
  onboardingLogo: <OnboardingLogo />,
  navArrow: <NavArrow />,
  homeMic: <HomeMic />,
  mic: <Mic />,
  // Menu icons
  arrowRight: <ArrowRight />,
  customerSupportMenu: <CustomerSupportMenu />,
  settingsMenu: <SettingsMenu />,
  termsConditionsMenu: <TermsConditionsMenu />,
  privacyPolicyFormMenu: <PrivacyPolicyFormMenu />,
  privacyPolicyMenu: <PrivacyPolicyMenu />,
  specialtyMenu: <SpecialtyMenu />,
  homeMenu: <HomeMenu />,
  lightMode: <LightMode />,
  darkMode: <MenuDarkMode />,
  logout: <MenuLogout />,
  menuTextSize: <MenuTextSize />,
  changePass: <ChangePass />,
  accountMenu: <AccountMenu />,
  phone: <Phone />,
  email: <Email />,
  heart: <Heart />,
  hearto: <Hearto />,
  // summaries
  summaries: <Summaries />,
  analysis: <Analysis />,
  predictions: <Predictions />,
  // Toast icons
  successAlert: <SuccessAlert />,
  errorAlert: <ErrorAlert />,
  warningAlert: <WarningAlert />,
  helpAlert: <HelpAlert />,
  successBubble: <SuccessBubble />,
  errorBubble: <ErrorBubble />,
  warningBubble: <WarningBubble />,
  helpBubble: <HelpBubble />,
  share: <Share />,
  user: <User />,
  lock: <Lock />,
  keyboardArrowDown: <KeyboardArrowDown />,
  history: <History />,
  search: <Search />,
  plus: <Plus />,
  recordBackground: <RecordBackground />,
  wave: <Wave />,
  send: <Send />,
  speak: <Speak />,
  advanceSearch: <AdvanceSearch />,
  resetSearch: <ResetSearch />,
  filterRemove: <FilterRemove />,
  alert: <Alert />,
  play: <Play />,
  translate: <Translate />,
  webClock: <WebClock />,
  info: <Info />,
  empty: <Empty />,
  arrowRightSmall: <ArrowRightSmall />,
  erh: <Erh />,
  checkSelect: <CheckSelect />,
  promptSelect: <PromptSelect />,
  copy: <Copy />,
  starOutline: <StarOutline />,
  more: <More />,
  chatShare: <ChatShare />,
  exportPdf: <ExportPdf />,
  copyMessage: <CopyMessage />,
  play2: <Play2 />,
  pause2: <Pause2 />,
  collapse: <Collapse />,
  expand: <Expand />,
};

export default icons;
